import * as Yup from 'yup';

export const productShape = Yup.object().shape({
    baseValue: Yup.number().default(5),
    brandCode: Yup.string(),
    brandName: Yup.string(),
    deliveryMethod: Yup.string().oneOf(['DIGITAL', 'PHYSICAL']),
    description: Yup.string().nullable(),
    inStoreRedemption: Yup.boolean(),
    isVariableValue: Yup.boolean(),
    label: Yup.string(),
    maxValue: Yup.number().default(2000),
    name: Yup.string(),
    onlineRedemption: Yup.boolean(),
    productCode: Yup.string(),
    activationInstructions: Yup.string().nullable(), 
    redemptionText: Yup.string().nullable(),
    termsAndConditions: Yup.string().nullable()
});
